// extracted by mini-css-extract-plugin
module.exports = {"mega-menu-side-navigation":"side-navigation_mega-menu-side-navigation__8kaqJ","mega-menu-side-navigation__content":"side-navigation_mega-menu-side-navigation__content__s6OKU"};